module.exports = __webpack_public_path__ + "img/bg06.4e3efd00.gif";